<template>
  <TirPmPopover
    classes="file-preview-confirm-delete-popover"
    ref="$popover"
    :position="PopoverPositionEnum.Top"
    @open="emit('update:isOpened', true)"
    @close="emit('update:isOpened', false)"
  >
  <div class="file-preview-confirm-delete-popover__target">
    <slot />
  </div>
    <template #content>
      <div class="file-preview-confirm-delete-popover__content">
        <span class="file-preview-confirm-delete-popover__title">
          Удалить документ?
        </span>
        <div class="file-preview-confirm-delete-popover__buttons">
          <TirPmButton
            :size="TirPmButtonSizeEnum.Small"
            :variant="TirPmButtonVariantEnum.PrimaryState"
            :is-disabled="isLoading"
            @click="close"
          >
            Отмена
          </TirPmButton>
          <TirPmButton
            :size="TirPmButtonSizeEnum.Small"
            :variant="TirPmButtonVariantEnum.SecondaryState"
            :is-loading="isLoading"
            @click="emit('onClickDelete')"
          >
            Удалить
          </TirPmButton>
        </div>
      </div>
    </template>
  </TirPmPopover>
</template>

<script lang="ts" setup>
import { PopoverPositionEnum, TirPmPopover } from "tir-pm-popover";
import {
  TirPmButton,
  TirPmButtonSizeEnum,
  TirPmButtonVariantEnum,
} from "tir-pm-button";
import { onMounted, ref } from "vue";

const emit = defineEmits<{
  /**Событие нажатие на кнопку удаления */
  (e: "onClickDelete"): void;
  /**Событие обновления флага открытия поповера */
  (e: "update:isOpened", value: boolean): void;
}>();

const props = defineProps({
  /**Открыт ли поповер */
  isOpened: {
    type: Boolean,
    default: false,
  },
  /**Загрузка */
  isLoading: {
    type: Boolean,
    default: false,
  },
});

/**Ссылка на элемент поповера */
const $popover = ref<InstanceType<typeof TirPmPopover>>();

const close = () => $popover.value?.close();
const open = () => $popover.value?.open();

defineExpose({
  close,
  open,
});
</script>

<style lang="scss" scoped>
@import "./file-preview-confirm-delete-popover.scss";
</style>
